export const dialogStyle = {
  maxWidth: "1200px",
  display: "flex",
  flexDirection: "column",
  background: "rgba(248, 247, 250, 1)",
};

export const dialogBox = {
  height: "min(800px, calc(100dvh - 64px))",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const currencySymbolStyle = {
  fontSize: "14px",
  fontWeight: 500,
  height: "32.125px",
  display: "flex",
  alignItems: "center",
  alignSelf: "flex-start",
};

export const visitPriceFieldStyle = {
  width: "75px",
  borderColor: "#2F2B3D38",
  color: "#2F2B3D",

  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "6px",
    padding: "0px",
    "& .MuiOutlinedInput-input": {
      padding: "6px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&[type=number]": {
        MozAppearance: "textfield",
      },
    },
    "& fieldset": {
      borderColor: "#E6E4EB",
    },
    "&:hover fieldset": {
      borderColor: "#46a091",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46a091",
    },

    "&.Mui-disabled": {
      backgroundColor: "#F8F7FA",
      "& fieldset": {
        borderColor: "#E6E4EB",
      },
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: { xs: 0, sm: "-58px" },
    marginRight: 0,
    fontSize: "13px",
    width: "max-content",
  },
};

export const locationServicesField = {
  ...visitPriceFieldStyle,
  width: "100%",
  maxWidth: "528px",
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    py: "10px",
    px: "12px",
  },
};

export const locationServicesPaperBox = {
  py: { xs: "8px", sm: "16px" },
  px: { xs: "16px", sm: "24px" },
  borderColor: "#EAEAEA",
  backgroundColor: "#fff",
  borderRadius: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const uploadFileButtonStyle = {
  backgroundColor: "#F2F3FB",
  color: "#257C6D",
  borderRadius: "8px",
  fontWeight: 500,
  textTransform: "none",
  fontSize: "15px",
  boxShadow: "none",
  px: "12px",
  py: "6px",
  // height: "39px",
  "&:hover": {
    backgroundColor: "#d6d6d6",
    boxShadow: "none",
  },
};

export const removeFileButtonStyle = {
  textTransform: "none",
  color: "#555",
  fontSize: "14px",
  marginTop: "2px",
  cursor: "pointer",
};

export const additionalStepTitleStyle = {
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "28px",
};

export const optionalStyle = {
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "28px",
};

export const additionalStepDescriptionStyle = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  color: "rgba(72, 72, 72, 0.7)",
};

export const visitPriceFlexStyle = {
  display: "flex",
  gap: "4px",
  alignItems: "flex-start",
  justifyContent: "space-between",
};

export const visitPriceFieldBoxStyle = (disabled) => ({
  display: "flex",
  gap: "4px",
  alignItems: "center",
  opacity: disabled ? 0.4 : 1,
  pointerEvents: disabled ? "none" : "auto",
});

export const experienceDetailsWrapperStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: "12px",
};

export const filesWrapperStyles = {
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
};

export const singleFileBoxStyles = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  borderRadius: "6px",
  paddingX: "8px",
  paddingY: "2px",
  backgroundColor: "#2F2B3D14",
};

export const singleFileLinkStyle = {
  textDecoration: "none",
  color: "#2F2B3D",
  fontWeight: 500,
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};
